import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 999999999999;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  background-color: ",
        ";\n  // background-attachment: fixed;\n  // background-size: 100% 100%;\n  // background-repeat: no-repeat;\n  // background-position: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: ",
        "px;\n  background-color: transparent;\n  // border-bottom: ",
        ";\n  transform: translate3d(0, 0, 0);\n\n  padding: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0;\n  // top: ",
        ";\n  left: 50%;\n  transform: translateX(-50%);\n  transition: top 0.2s;\n  height: ",
        ";\n  width: 100%;\n  max-width: 1400px;\n  z-index: 21;\n  background: ",
        ";\n  border-radius: 0;\n  ",
        " {\n    border-radius: 8px 8px 30px 30px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  flex-grow: 1;\n  transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate3d(0, 0, 0);\n  max-width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  right: 0;\n  top: 30%;\n  // transform: translateY(-50%);\n  background-image: ",
        ";\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 90px;\n  height: 302px;\n  z-index: 99;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  padding: 12px;\n  border-radius: 16px;\n  line-height: normal;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import throttle from "lodash/throttle";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTheme as useNextTheme } from "next-themes";
import styled from "styled-components";
import BottomNav from "../../components/BottomNav";
import { Box } from "../../components/Box";
import { Text } from "../../components/Text";
import { ThemeSwitcher } from "../../components/ThemeSwitcher";
import Flex from "../../components/Box/Flex";
import { IconButton } from "../../components/Button";
import Footer from "../../components/Footer";
import MenuItems from "../../components/MenuItems/MenuItems";
// import { SubMenuItems } from "../../components/SubMenuItems";
import { useMatchBreakpoints } from "../../contexts";
// import CakePrice from "../../components/CakePrice/CakePrice";
import { MenuZoomIcon } from "../../components/Svg";
import Logo from "./components/Logo";
// import { darkColors } from "../../theme/colors";
import { MENU_HEIGHT, MOBILE_MENU_HEIGHT } from "./config";
import { socials } from "../../components/Footer/config";
import { Link } from "../../components/Link";
import LangSelector from "../../components/LangSelector/LangSelector";
import { MenuContext } from "./context";
var mediaDark = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOTBweCIgaGVpZ2h0PSIzMDJweCIgdmlld0JveD0iMCAwIDkwIDMwMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDx0aXRsZT5zd2FwX2ljb25faGVpc2U8L3RpdGxlPgogICAgPGcgaWQ9Iumhtemdoi0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0i5q2l6aqkNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE4MzAuMDAwMDAwLCAtMzg5LjAwMDAwMCkiIGZpbGw9IiMxRTFGMjIiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTkyMCwzODkgTDE5MTkuOTk5LDQxNy45NDEgTDE5MjMsNDE3Ljk0MTE4NCBMMTkyMyw2NjEuOTQxMTg0IEwxOTIwLDY2MS45NDEgTDE5MjAsNjkwLjkyMzI4NSBDMTkxOS44NTIsNjcxLjYyOTE2MiAxOTA4LjYwOTg0LDY2MS45ODIxMDEgMTg4Ni4yNzM1Myw2NjEuOTgyMTAxIEMxODg1LjY2OTYsNjYxLjk4MjEwMSAxODg1LjA4MTEyLDY2MS45Njg5NDcgMTg4NC41MDgwNyw2NjEuOTQyNjM4IEwxODc2LjUsNjYxLjk0MTE4NCBDMTg1MC44MTg3Niw2NjEuOTQxMTg0IDE4MzAsNjQxLjEyMjQyNCAxODMwLDYxNS40NDExODQgTDE4MzAsNDY0LjQ0MTE4NCBDMTgzMCw0MzguNzU5OTQzIDE4NTAuODE4NzYsNDE3Ljk0MTE4NCAxODc2LjUsNDE3Ljk0MTE4NCBMMTg4Ni4yNzM1Myw0MTcuOTQxMTg0IEMxOTA4LjYwOTg0LDQxNy45NDExODQgMTkxOS44NTIsNDA4LjI5NDEyMiAxOTIwLDM4OSBMMTkyMCwzODkgWiIgaWQ9InN3YXBfaWNvbl9oZWlzZSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
var mediaLight = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOTFweCIgaGVpZ2h0PSIzMDJweCIgdmlld0JveD0iMCAwIDkxIDMwMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDx0aXRsZT5zd2FwX2ljb25fc2hlbWVpPC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWRhc2hhcnJheT0iMCwwIj4KICAgICAgICA8ZyBpZD0i5YWR5o2i6aaW6aG1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTgyOS4wMDAwMDAsIC0zODkuMDAwMDAwKSIgZmlsbD0iI0YzRjRGNyIgc3Ryb2tlPSIjREJEQ0UwIj4KICAgICAgICAgICAgPHBhdGggZD0iTTE5MjAsMzg5IEwxOTE5Ljk5OSw0MTcuOTQxIEwxOTIzLDQxNy45NDExODQgTDE5MjMsNjYxLjk0MTE4NCBMMTkyMCw2NjEuOTQxIEwxOTIwLDY5MC45MjMyODUgQzE5MTkuODUyLDY3MS42MjkxNjIgMTkwOC42MDk4NCw2NjEuOTgyMTAxIDE4ODYuMjczNTMsNjYxLjk4MjEwMSBDMTg4NS42Njk2LDY2MS45ODIxMDEgMTg4NS4wODExMiw2NjEuOTY4OTQ3IDE4ODQuNTA4MDcsNjYxLjk0MjYzOCBMMTg3Ni41LDY2MS45NDExODQgQzE4NTAuODE4NzYsNjYxLjk0MTE4NCAxODMwLDY0MS4xMjI0MjQgMTgzMCw2MTUuNDQxMTg0IEwxODMwLDQ2NC40NDExODQgQzE4MzAsNDM4Ljc1OTk0MyAxODUwLjgxODc2LDQxNy45NDExODQgMTg3Ni41LDQxNy45NDExODQgTDE4ODYuMjczNTMsNDE3Ljk0MTE4NCBDMTkwOC42MDk4NCw0MTcuOTQxMTg0IDE5MTkuODUyLDQwOC4yOTQxMjIgMTkyMCwzODkgTDE5MjAsMzg5IFoiIGlkPSJzd2FwX2ljb25fc2hlbWVpIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
var MaskWrapper = styled.div.withConfig({
    componentId: "sc-ca61ca26-0"
})(_templateObject());
var Wrapper = styled.div.withConfig({
    componentId: "sc-ca61ca26-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.isDark ? "#303338" : "#fff";
});
var StyledNav = styled.nav.withConfig({
    componentId: "sc-ca61ca26-2"
})(_templateObject2(), function(param) {
    var isMobile = param.isMobile;
    return !isMobile ? MENU_HEIGHT : MOBILE_MENU_HEIGHT;
}, function(param) {
    var isMobile = param.isMobile, theme = param.theme;
    return !isMobile ? "1px solid ".concat(theme.colors.cardBorder2) : "none";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "0 16px" : "0 30px";
});
var FixedContainer = styled.div.withConfig({
    componentId: "sc-ca61ca26-3"
})(_templateObject3(), function(param) {
    var showMenu = param.showMenu, height = param.height;
    return showMenu ? 0 : "-".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var theme = param.theme, isScrollTop = param.isScrollTop;
    return isScrollTop ? theme.isDark ? "#1E1F22" : "#F3F4F7" : theme.isDark ? "#1E1F22" : "#F3F4F7";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
// const TopBannerContainer = styled.div<{ height: number }>`
//   height: ${({ height }) => `${height}px`};
//   min-height: ${({ height }) => `${height}px`};
//   max-height: ${({ height }) => `${height}px`};
//   width: 100%;
// `;
// background: ${({ theme }) =>
// theme.isDark ? "transparent" : "linear-gradient(180deg, rgba(90,173,255,0.15) 0%, rgba(197,241,28,0.1) 100%)"};
var BodyWrapper = styled(Box).withConfig({
    componentId: "sc-ca61ca26-4"
})(_templateObject4());
var Inner = styled.div.withConfig({
    componentId: "sc-ca61ca26-5"
})(_templateObject5());
export var StyledFooter2 = styled(Flex).withConfig({
    componentId: "sc-ca61ca26-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.isDark ? "url(".concat(mediaDark, ")") : "url(".concat(mediaLight, ")");
});
export var WrapperItem = styled(Flex).withConfig({
    componentId: "sc-ca61ca26-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.isDark ? "#31363C" : "#fff";
});
var Menu = function(param) {
    var _linkComponent = param.linkComponent, linkComponent = _linkComponent === void 0 ? "a" : _linkComponent, // banner,
    rightSide = param.rightSide, isDark = param.isDark, toggleTheme = param.toggleTheme, currentLang = param.currentLang, setLang = param.setLang, cakePriceUsd = param.cakePriceUsd, links = param.links, subLinks = param.subLinks, footerLinks = param.footerLinks, activeItem = param.activeItem, activeSubItem = param.activeSubItem, langs = param.langs, buyCakeLabel = param.buyCakeLabel, children = param.children;
    var setTheme = useNextTheme().setTheme;
    var isMobile = useMatchBreakpoints().isMobile;
    var ref = useState(true), showMenu = ref[0], setShowMenu = ref[1];
    var ref1 = useState(false), isScrollTop = ref1[0], setScrollTop = ref1[1];
    var ref2 = useState(true), isUnmounting = ref2[0], setIsUnmounting = ref2[1];
    var refPrevOffset = useRef("object" === "undefined" ? 0 : window.pageYOffset);
    // show overlay
    var isShowPopup = localStorage.getItem("isShowPopup") === "1";
    var totalTopMenuHeight = !isMobile ? MENU_HEIGHT : MOBILE_MENU_HEIGHT;
    // const totalTopMenuHeight2 = !isMobile ? MENU_HEIGHT + 20 : MOBILE_MENU_HEIGHT + 10;
    useEffect(function() {
        if (!isShowPopup) {
            // console.log("isShowPopup===", isShowPopup);
            setIsUnmounting(true);
        } else {
            setIsUnmounting(false);
        }
        var handleScroll = function() {
            var currentOffset = window.pageYOffset;
            var isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight;
            var isTopOfPage = currentOffset === 0;
            // console.log("currentOffset====", currentOffset, isBottomOfPage, isTopOfPage)
            if (currentOffset > 78) {
                setScrollTop(true);
            }
            // Always show the menu when user reach the top
            if (isTopOfPage) {
                setShowMenu(false);
                setScrollTop(false);
            } else if (!isBottomOfPage) {
                if (currentOffset < refPrevOffset.current || currentOffset <= totalTopMenuHeight) {
                    // Has scroll up
                    setShowMenu(true);
                } else {
                    // Has scroll down
                    setShowMenu(false);
                }
            }
            refPrevOffset.current = currentOffset;
        };
        var throttledHandleScroll = throttle(handleScroll, 200);
        window.addEventListener("scroll", throttledHandleScroll);
        return function() {
            window.removeEventListener("scroll", throttledHandleScroll);
        };
    }, [
        totalTopMenuHeight,
        isShowPopup,
        setIsUnmounting
    ]);
    useEffect(function() {
        if (!window.localStorage.getItem("theme")) {
            setTheme("dark");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Find the home link if provided
    var homeLink = links.find(function(link) {
        return link.label === "Home";
    });
    // const subLinksWithoutMobile = subLinks?.filter((subLink) => !subLink.isMobileOnly);
    // const subLinksMobileOnly = subLinks?.filter((subLink) => subLink.isMobileOnly);
    var handleToggle = useCallback(function() {
        // console.log(isUnmounting, isShowPopup, localStorage.getItem("isShowPopup"))
        if (isShowPopup) {
            window.localStorage.removeItem("isShowPopup");
            setIsUnmounting(true);
        } else {
            window.localStorage.setItem("isShowPopup", "1");
            setIsUnmounting(false);
        }
    }, [
        isShowPopup,
        setIsUnmounting
    ]);
    var ref3;
    return /*#__PURE__*/ _jsxs(MenuContext.Provider, {
        value: {
            linkComponent: linkComponent
        },
        children: [
            /*#__PURE__*/ _jsx(MaskWrapper, {
                children: /*#__PURE__*/ _jsx(Flex, {
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    children: /*#__PURE__*/ _jsx(Text, {
                        fontSize: "28px",
                        children: "System Maintenance in Progress..."
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx(FixedContainer, {
                        isScrollTop: isScrollTop,
                        showMenu: showMenu,
                        height: totalTopMenuHeight,
                        children: /*#__PURE__*/ _jsxs(StyledNav, {
                            isMobile: isMobile,
                            style: {
                                backgroundColor: isShowPopup && isMobile ? isDark ? "#4E5058" : "#F8F7F7" : "transparent"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Flex, {
                                    children: /*#__PURE__*/ _jsx(Logo, {
                                        isDark: isDark,
                                        href: (ref3 = homeLink === null || homeLink === void 0 ? void 0 : homeLink.href) !== null && ref3 !== void 0 ? ref3 : "/"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Flex, {
                                    children: !isMobile && /*#__PURE__*/ _jsx(MenuItems, {
                                        items: links,
                                        activeItem: activeItem,
                                        activeSubItem: activeSubItem,
                                        ml: "24px"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Flex, {
                                    alignItems: "center",
                                    height: "100%",
                                    children: [
                                        rightSide,
                                        !isMobile && /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Box, {
                                                    mt: "4px",
                                                    children: /*#__PURE__*/ _jsx(LangSelector, {
                                                        currentLang: currentLang,
                                                        langs: langs,
                                                        setLang: setLang,
                                                        buttonScale: "md",
                                                        color: "textSubtle"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Box, {
                                                    children: /*#__PURE__*/ _jsx(ThemeSwitcher, {
                                                        isDark: isDark,
                                                        toggleTheme: function() {
                                                            return setTheme(isDark ? "light" : "dark");
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        isMobile && /*#__PURE__*/ _jsx(IconButton, {
                                            variant: "text",
                                            scale: "sm",
                                            ml: "6px",
                                            onClick: handleToggle,
                                            children: /*#__PURE__*/ _jsx(MenuZoomIcon, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(BodyWrapper, {
                        pt: "".concat(totalTopMenuHeight, "px"),
                        children: !isMobile ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Inner, {
                                    isPushed: false,
                                    showMenu: showMenu,
                                    children: children
                                }),
                                /*#__PURE__*/ _jsx(StyledFooter2, {
                                    children: /*#__PURE__*/ _jsx(Flex, {
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mx: [
                                            "0",
                                            "auto"
                                        ],
                                        children: socials.map(function(social, index) {
                                            var iconProps = {
                                                width: "24px",
                                                // height: "20px",
                                                // color: isDark ? "#C3C9D0" : "#002236",
                                                style: {
                                                    cursor: "pointer"
                                                }
                                            };
                                            var Icon = social.icon;
                                            // const mr = index < socials.length - 1 ? "24px" : 0;
                                            return /*#__PURE__*/ _jsx(Link, {
                                                external: true,
                                                href: social.href,
                                                "aria-label": social.label,
                                                style: {
                                                    marginBottom: index !== 2 ? "18px" : "0"
                                                },
                                                children: /*#__PURE__*/ _jsx(WrapperItem, {
                                                    children: /*#__PURE__*/ _jsx(Icon, _object_spread({}, iconProps))
                                                })
                                            }, social.label);
                                        })
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ _jsxs(Inner, {
                            isPushed: false,
                            showMenu: showMenu,
                            children: [
                                children,
                                /*#__PURE__*/ _jsx(Footer, {
                                    items: footerLinks,
                                    isDark: isDark,
                                    toggleTheme: toggleTheme,
                                    langs: langs,
                                    setLang: setLang,
                                    currentLang: currentLang,
                                    cakePriceUsd: cakePriceUsd,
                                    buyCakeLabel: buyCakeLabel
                                })
                            ]
                        })
                    }),
                    isMobile && !isUnmounting && /*#__PURE__*/ _jsx(BottomNav, {
                        items: links,
                        activeItem: activeItem,
                        activeSubItem: activeSubItem,
                        currentLang: currentLang,
                        langs: langs,
                        setLang: setLang,
                        onClose: handleToggle,
                        isUnmounting: !isUnmounting
                    })
                ]
            })
        ]
    });
};
export default Menu;
